var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vform-sign-out pr-1 d-inline-block clickable",on:{"click":function($event){return _vm.$emit('signOut')}}},[_c('icon',{attrs:{"type":"sign-out-alt"}}),_vm._v(" "+_vm._s(_vm.$t('signOut'))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }